var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"content-class":"custom_dialog","persistent":""},model:{value:(_vm.isSomethingLoading),callback:function ($$v) {_vm.isSomethingLoading=$$v},expression:"isSomethingLoading"}},[_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"white"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }